export default __webpack_public_path__ + "static/media/manicure-black.c6f101a5.svg";